import React, {useEffect, useState} from 'react';
import create from '../../images/projectdetails/add.png';
import trash from '../../images/common/trash.png';
import edit from '../../images/common/edit.png';
import download from '../../images/projectdetails/download.png';
import post from '../../images/projectdetails/share.png';
import Upload from '../popups/Upload';
import '../../scss/reusables/projectinfo.scss';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import FormSubmission from '../popups/FormSubmission';
import getResponse from '../actions/Project';
import Config from '../actions/Config';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';
import DeleteItem from '../popups/DeleteItem';
import { MentionsInput, Mention } from 'react-mentions'
import parse from 'html-react-parser';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import { CSVLink } from "react-csv";
import Snackbars from '../Reusables/Snackbar';
import { CopyToClipboard } from "react-copy-to-clipboard";
import Tooltip from "@material-ui/core/Tooltip";
import downloadBlue from '../../images/common/download-blue-borderless.png';
import { convertToDateString, convertUTCToPST, getCSVData, escapeHtml } from '../Reusables/Function';
import Descriptor from '../Reusables/Descriptor';
import DiscussionDescriptor from './DiscussionDescriptor';

const BASE_URL = Config();
function ProjectInfo(props) {
    const { fivetasks, fivefiles, fiveforms, complete, setComplete, 
        setDeleteForm, deleteform, setDeleteFile, deletefile, 
        setDeleteTask, deletetask, setUpload, uploadstate, completecount, 
        showTasks, showTask, isHidden } = props;
    const userId = useSelector((state) => state.userId);
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [loadend, setLoadEnd] = useState(false);
    const [alltasks, setTask] = useState([]);
    const [allfiles, setFile] = useState([]);
    const [allforms, setForm] = useState([]);
    const [discussion, setDiscussion] = useState([]);
    const [postdata, SetPost] = useState('');
    const [taskid, setTaskid] = useState([]);
    const [sortstate, setSort] = useState(false);
    const [showalltask, setShowalltask] = useState(false);
    const [checkAll, setCheckAll] = useState(null);
    const [showallfile, setShowallfile] = useState(true);
    const [showallform, setShowallform] = useState(false);
    const [formlistdata, setFormlistdata] = useState('');
    const [idarray, setIdarray] = useState([]);
    const [deleteTaskId, setDeleteTaskId] = useState(null);
    const [deleteFormId, setDeleteFormId] = useState(null);
    const [deleteFileId, setDeleteFileId] = useState(null);
    const [users, serUserList] = useState([]);
    const accesstoken =  Cookies.get('access_token');
    const [completestate, setCompletestate] = useState(false);
    const [completebutton, setCompletebutton] = useState(true);
    const [discussinerror, setErrorDiscussion] = useState('');
    const [uploaderror, setUploaderror] = useState('');
    const [taskerror, setTaskerror] = useState('');
    const [open, setOpen] = useState(null)
    const [created, setCreate] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [tooltipMessage, setTooltipMessage] = useState("Copy Link")
    const [isClicked, setClick] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [downloadLink, setDownloadLink] = useState([]);
    const [formEditted, setFormEditted] = useState(null);
    function handleShow() {
        setShow(true);
        setLoadEnd(false);
        setUploaderror('');
        setCreate(!created);
    }
  
    const [showform, setShowform] = useState(false);
    const handleFormShow = () => {
        setShowform(true);
        setToggle(!toggle)
    }
    const handleFormHide = () => setShowform(false);

    const [showDeleteTask, setShowDeleteTask] = useState(false);
    const handleCloseTaskPopup = () => setShowDeleteTask(false);
    const handleShowTaskPopup = () => setShowDeleteTask(true);

    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const handleCloseFormPopup = () => setShowDeleteForm(false);
    const handleShowFormPopup = () => setShowDeleteForm(true);

    const [showDeleteFile, setShowDeleteFile] = useState(false);
    const handleCloseFilePopup = () => setShowDeleteFile(false);
    const handleShowFilePopup = () => setShowDeleteFile(true);
    
    var tasklist = showalltask ? alltasks : fivetasks
    var filelist = showallfile ? allfiles : fivefiles

    const [fiveFormsList, setFiveFormsList] = useState([]);
    const [formsList, setFormsList] = useState([]);
    // var formlist = showallform ? allforms : fiveforms
    var forms = showallform ? formsList : fiveFormsList;

    const params = new URLSearchParams(location.search);
    const sort = params.has('sort') ? params.get('sort') : ''
    const sort_order = params.has('sort_order') ? params.get('sort_order') : ''

    function Checkall(e) {
        setShowalltask(true);
        setCheckAll(e.target.checked);
    }

    function handleformdata(item) {
        handleFormShow();
        setFormlistdata(item);
    }

    function TaskEditNavigate(event, taskid) {
        console.log("IDUNV", `/projects/${id}/edit`);
        event.stopPropagation();
        navigate(`/projects/${id}/task/${taskid}/edit`);
    }

    function TaskCreateNavigate(event) {
        event.stopPropagation();
        navigate(`/projects/${id}/task/new`);
    }

    function Check(e, id) {
        setCompletestate(!completestate);
        console.log("ITEM", id);
        if(idarray.includes(id)) {
            let idarraynew = idarray.filter((idarray) => { return idarray !== id });
            setIdarray(idarraynew);
        }
        else {
            setIdarray(idarray.concat(id));
        }
        e.stopPropagation();
    }

    function Complete() {
        setCompletebutton(true);
        const data = {
            "ids" : idarray
        }
        console.log("COMPLETE", data)
        const URL = `/api/project/${id}/tasks/complete`
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.CompleteTask(data, accesstoken, URL, (response) => {
                    console.log("COMPLETEERROR1", response);
                    if(response && response.status === 200) {
                        setTaskerror('');
                        setOpen(false)
                        document.getElementsByClassName('checkbox-multi')[0].checked = false;
                        console.log("CompleteTask", response.data.data['ids']);
                        let deletedids = response.data.data['ids'];
                        let arr = idarray.filter(item => !deletedids.includes(item))
                        setIdarray(arr);
                        setComplete(!complete);
                        var checkboxelem = document.getElementsByClassName('checkboxes');
                        for(var i=0; i<checkboxelem.length; i++) {
                            if(document.getElementsByClassName('checkboxes')[i].checked === true) {
                                document.getElementsByClassName('checkboxes')[i].checked = false
                            }
                        }
                    }
                    if(response && response.status === 404) {
                        console.log("COMPLETEERROR2", response.data.message);
                        setTaskerror(response.data.message);
                        setOpen(true)
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function DeleteForm(e, formid) {
        e.stopPropagation();
        setDeleteFormId(formid);
        handleShowFormPopup();
    }

    function CallDeleteFormApi() {
        const URL = `/api/project/form/delete/${deleteFormId}`
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.DeleteForm(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        console.log("DeleteForm", response);
                        setDeleteForm(deleteFormId);
                        handleCloseFormPopup();
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function DeleteFile(e, fileid) {
        e.stopPropagation();
        setDeleteFileId(fileid);
        handleShowFilePopup();
    } 

    function callDeleteFileApi() {
        const URL = `/api/project/file/delete/${deleteFileId}`
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.DeleteFile(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        console.log("DeleteFile", response);
                        setDeleteFile(deleteFileId);
                        handleCloseFilePopup();
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function DeleteTask(e, taskid) {
        e.stopPropagation();
        setDeleteTaskId(taskid);
        handleShowTaskPopup();
    }
    
    function CallDeleteTaskApi() {
        const URL = `/api/project/task/delete/${deleteTaskId}`
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.DeleteTask(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        console.log("DeleteTask", response);
                        setDeleteTask(deleteTaskId);
                        handleCloseTaskPopup();
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function Toggle(id) {
        if(taskid.includes(id)) {
            let taskidnew = taskid.filter((taskid) => { return taskid !== id});
            setTaskid(taskidnew);
        }
        else {
            console.log("idTo", id);
            setTaskid(taskid.concat(id));
        }
    }

    function ShowTask() {
        setShowalltask(!showalltask);
    }

    function ShowFile() {
        setShowallfile(!showallfile);
    }

    function ShowForm() {
        setShowallform(!showallform);
    }

    function Post() {
        if(isClicked == false && postdata != "" && postdata != null) {
            setClick(true);
        }
    }

    // useEffect(() => {
    //     if(isClicked == true) {
            
    //     }
    // }, [isClicked])

    // const handleKey = (e) => {
    //     if (e.key == 'Enter') {
    //         e.preventDefault();
    //         if(e.target.value.length > 0) {
    //             Post();
    //         }
    //     }
    // }

    const sendDiscussion = (msg) => {
        if(msg != '' && msg != null && userId != '' && msg != null ){
                const data = {  
                    Author: userId != null && userId != '' && userId,
                    Message: msg != null && msg != ''&& msg
                }
                const URL = `/api/Project/${id}/discussion/add`
                console.log('data', data);
                function CallAPI(accesstoken) {
                    if(accesstoken === '') {
                        navigate('/login');
                    }
                    else {
                        getResponse.CreatePost(data, accesstoken, URL, (response) => {
                            console.log("POST", response);
                            if(response.status === 200) {
                                console.log("Discussion API is called", isClicked);
                                SetPost('');
                                const URL = `/api/Project/${id}/discussions`
                                getResponse.GetDiscussion(URL, accesstoken, (response) => {
                                    if(response.status == 200) {
                                        console.log("Filesdis", response.data);
                                        setDiscussion(response.data.data);
                                        let chatWindow = document.getElementsByClassName('discussion-scroll-section')[0]; 
                                        var xH = chatWindow.scrollHeight; 
                                        chatWindow.scrollTo(0, xH);
                                    } else if(response.status == 401) {
                                        navigate("/login")
                                    }
                                });
                                setErrorDiscussion("");
                                setClick(false);
                            }
                            if(response.status === 400) {
                                setErrorDiscussion(response.data.message);
                                setClick(false);
                            } else if(response.status == 401) {
                                navigate("/login")
                            }
                        });
                    }
                }
                RefreshToken((accesstoken) => CallAPI(accesstoken));
            }
    }

    useEffect(() => {
        setOpen(false)
        const params = new URLSearchParams(location.search);
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const URL = `/api/Project/${id}/tasks${sort ? `?sort_by=${sort}` : ''}${sort_order ? `&sort_type=${sort_order}` : ''}`
        console.log("URL", `/api/Project/${id}/tasks${sort ? `?sort_by=${sort}` : ''}${sort_order ? `&sort_type=${sort_order}` : ''}`);  
        getResponse.GetTaskList(URL, accesstoken, (response) => {
            if(response.status == 200) {
                console.log("TASKES", response.data);
                setTask(response.data.data);
                console.log("USECOM");
            } else if(response.status == 401) {
                navigate("/login")
            }
        });
    }, [complete, deletetask, sortstate, showTasks, showTask])
    
    useEffect(() => {
        setOpen(false)
        const params = new URLSearchParams(location.search);
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const URL = `/api/Project/${id}/files${sort ? `?sort_by=${sort}` : ''}${sort_order ? `&sort_type=${sort_order}` : ''}`
        console.log("URLfile", URL);
        getResponse.GetFilesList(URL, accesstoken, (response) => {
            if(response.status == 200) {
                console.log("Files", response.data);
                setFile(response.data.data);
            } else if(response.status == 401) {
                navigate("/login")
            }        
        });
    }, [deletefile, uploadstate, sortstate])

    useEffect(() => {
        callFormListApi()
    }, [deleteform, sortstate])

    useEffect(() => {
        if(formEditted) {
            callFormListApi();
        }
    }, [formEditted])

    const callFormListApi = () => {
        setOpen(false)
        const params = new URLSearchParams(location.search);
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const URL = `/api/Project/${id}/forms${sort ? `?sort_by=${sort}` : ''}${sort_order ? `&sort_type=${sort_order}` : ''}`
       
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.GetFormList(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        setFormEditted(false);
                        // setForm(response.data.data);
                        
                        if(response.data.data.length <= 5) {
                            setFiveFormsList(response.data.data);
                            setFormsList(response.data.data);
                        } else {
                            var forms = [];
                            for(var i = 0; i < 5; i++) {
                                forms.push(response.data.data[i])
                            }
                            setFiveFormsList(forms);
                            setFormsList(response.data.data);
                        }

                        let csvdata = new Array();

                        setDownloadLink(getCSVData(response.data.data));

                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    useEffect(() => {
        setOpen(false)
        if(document.getElementsByClassName('checkbox-multi')[0]) {
            if(completecount === alltasks.length || alltasks.length === 0) {
                document.getElementsByClassName('checkbox-multi')[0].checked = false;
                document.getElementsByClassName('checkbox-multi')[0].style.opacity = 0;
                document.getElementsByClassName('checkbox-multi')[0].setAttribute('disabled', true);
                document.getElementsByClassName('checkbox-multi')[0].style.cursor = "auto";
            }
            else {
                document.getElementsByClassName('checkbox-multi')[0].style.opacity = 1;
                document.getElementsByClassName('checkbox-multi')[0].removeAttribute('disabled', true);
                document.getElementsByClassName('checkbox-multi')[0].style.cursor = "pointer";
            }
        }
    }, [completecount,alltasks])

    function SortTask(dataset) {
        let sortBy = dataset.sortBy;
        let sortType = dataset.sortType;
        if(window.location.href.includes('view')) {
            navigate(`/projects/${id}/view?sort=${sortBy}&sort_order=${sortType}`);
        }
        if(window.location.href.includes('edit')) {
            navigate(`/projects/${id}/edit?sort=${sortBy}&sort_order=${sortType}`);
        }
        if(sortType === 'asc') {
            setShowalltask(true);
            setSort(!sortstate);
        }
        else {
            setShowalltask(true);
            setSort(!sortstate);
        }
    }
    
    function SortFile(dataset) {
        let sortBy = dataset.sortBy;
        let sortType = dataset.sortType;
        if(window.location.href.includes('view')) {
            navigate(`/projects/${id}/view?sort=${sortBy}&sort_order=${sortType}`);
        }
        if(window.location.href.includes('edit')) {
            navigate(`/projects/${id}/edit?sort=${sortBy}&sort_order=${sortType}`);
        }
        if(sortType === 'asc') {
            setShowallfile(true);
            setSort(!sortstate);
        }
        else {
            setShowallfile(true);
            setSort(!sortstate);
        }
    }

    function SortForm(dataset) {
        let sortBy = dataset.sortBy;
        let sortType = dataset.sortType;
        if(window.location.href.includes('view')) {
            navigate(`/projects/${id}/view?sort=${sortBy}&sort_order=${sortType}`);
        }
        if(window.location.href.includes('edit')) {
            navigate(`/projects/${id}/edit?sort=${sortBy}&sort_order=${sortType}`);
        }
        if(sortType === 'asc') {
            setShowallform(true);
            setSort(!sortstate);
        }
        else {
            setShowallform(true);
            setSort(!sortstate);
        }
    }

    useEffect(() => {
        function getUserList(response) {
            const usersArray = [];
            response.map((user) => {
                const userObject = {id: 0, display: ''}
                if(!(userId === user["idUsers"])) {
                    userObject.id = user["idUsers"];
                    userObject.display = ((user["firstName"] != null && user["lastName"] != null) ? 
                        (user["firstName"]+" "+user["lastName"]) : (user["firstName"]));
                    usersArray.push(userObject);
                }
            })
            return usersArray;
        }

        const assignendpoint = "/api/users/list";
        getResponse.GetAssignDropdown(accesstoken, assignendpoint, (response) => {
            if(response.status == 200) {
                const usersArray =  getUserList(response.data.data);
                serUserList(usersArray);
            } else if(response.status == 401) {
                navigate("/login")
            }
        });

        const URL = `/api/Project/${id}/discussions`
        getResponse.GetDiscussion(URL, accesstoken, (response) => {
            if(response.status == 200) {
                console.log("Files", response.data);
                setDiscussion(response.data.data);
            } else if(response.status == 401) {
                navigate("/login")
            }
        });
      
    }, [])
    console.log("users", users);

    useEffect(() => {
        setOpen(false)
        var checkboxelem = document.getElementsByClassName('checkboxes');
        var checkarray = new Array();
        var checkarraytrue = new Array();
        for(var i=0; i<checkboxelem.length; i++) {
            checkarray.push(checkboxelem[i].checked);
            checkarraytrue.push(true);
            var checkarrayvalue = checkarray;
            var checkarraytruevalue = checkarraytrue;
        }
        if(checkarrayvalue) {
            if(checkarrayvalue.includes(true)) {
                setCompletebutton(false);
            }
            else {
                setCompletebutton(true);
                document.getElementsByClassName('checkbox-multi')[0].checked = false;
            }
        }
        if(checkarrayvalue && checkarraytruevalue) {
            if(JSON.stringify(checkarrayvalue) === JSON.stringify(checkarraytruevalue)) {
                document.getElementsByClassName('checkbox-multi')[0].checked = true;
            }
            else {
                document.getElementsByClassName('checkbox-multi')[0].checked = false;
            }
        }  
    }, [completestate])

    useEffect(() => {
        setOpen(false)
        const location = window.location.href;
        const section = location.substring(location.indexOf('#')+1, location.length);
        if( document.getElementById(`${section}`)) {
            document.getElementById(`${section}`).scrollIntoView({
                behavior: 'smooth'
            });
        }
    }, [])

    useEffect(() => {
        if(checkAll != null) {
            setCompletestate(!completestate);
            setIdarray([]);
            if(checkAll  === true) {
                var checkboxelem = document.getElementsByClassName('checkboxes');
                var valuesid = new Array();
                for(var i=0; i<checkboxelem.length; i++) {
                    document.getElementsByClassName('checkboxes')[i].checked = true;
                    let value = document.getElementsByClassName('checkboxes')[i].value;
                    console.log("value", value);
                    valuesid.push(Number(value));
                }
                setIdarray(valuesid);
            }
            else {
                var checkboxelem = document.getElementsByClassName('checkboxes');
                for(var i=0; i<checkboxelem.length; i++) {
                    document.getElementsByClassName('checkboxes')[i].checked = false;
                }
            }
        }
    }, [showalltask, checkAll])

    const handleMouseLeave = () => {
        setTooltipMessage("Copy Link")
    }
    const handleFormDownload = (e, item, index) => {
        e.stopPropagation();
        const element = document.createElement("a");
        element.href = downloadLink[index];
        element.download = `${item.title}.txt`;
        document.body.appendChild(element);
        element.click();
    }

    const handleDownloadImages = async (pictures) => {
        for (var i = 0; i< pictures.length; i++) {
        const response = await fetch(`${BASE_URL}/${pictures[i].fileUrl && pictures[i].fileUrl}`);
        let filename = pictures[i].fileName;
        response.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
        });
      }
    }

    return (
        <div className='project-info'>
            <div id='tasks' className='task-section'>
                <div className='task-container'>
                    <div className='task-left'>
                        <div className='tasks'>Tasks</div>
                        <div className='showing'>Showing { tasklist && tasklist.length } tasks of { alltasks && alltasks.length }</div>
                        {  alltasks && alltasks.length > 5 &&
                            <div className='showall' onClick={ShowTask}>{showalltask ? "Show Less" : "Show All"}</div>
                        }
                    </div>
                    {!isHidden && 
                    <div className='task-right'>
                        <button disabled={completebutton ? true : false} className={completebutton ? "disablecomplete" : "enablecomplete"} onClick={Complete}>Complete</button>
                        <img src={create} alt='create' onClick={(e) => TaskCreateNavigate(e)}></img>
                    </div>}
                </div>
                <div className='task-table'>
                    <table>
                        <thead>
                            <tr className='heading-row'>
                                {!isHidden && 
                                <th className='heading-data first-data' style={{minWidth: "35px"}}>
                                    <input type="checkbox" className='checkbox-multi check-box' onClick={(e) => Checkall(e)}></input>
                                </th>}
                                <th className='heading-data' style={{minWidth: "170px", maxWidth: "220px", width: "220px"}}>
                                    <div className='heading-arrows'>
                                        <div>Task</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'taskname' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='taskname' data-sort-type='asc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'taskname' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='taskname' data-sort-type='desc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "130px"}}>
                                    <div className='heading-arrows'>
                                        <div>Assigned to</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'assigned_to' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='assigned_to' data-sort-type='asc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'assigned_to' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='assigned_to' data-sort-type='desc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "120px"}}>
                                    <div className='heading-arrows'>
                                        <div>Dependency</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'taskdependency' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='taskdependency' data-sort-type='asc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'taskdependency' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='taskdependency' data-sort-type='desc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "110px"}}>
                                    <div className='heading-arrows'>
                                        <div>Due Date</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'duedate' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='duedate' data-sort-type='asc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'duedate' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='duedate' data-sort-type='desc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "90px"}}>
                                    <div className='heading-arrows'>
                                        <div>Status</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'status' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='status' data-sort-type='asc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'status' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='status' data-sort-type='desc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "120px"}}>
                                    <div className='heading-arrows'>
                                        <div>Priority</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'priority' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='priority' data-sort-type='asc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'priority' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='priority' data-sort-type='desc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "170px"}}>
                                    <div className='heading-arrows'>
                                        <div>Last Updated</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'last_updated' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='last_updated' data-sort-type='asc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'last_updated' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='last_updated' data-sort-type='desc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "160px"}}>
                                    <div className='heading-arrows'>
                                        <div>Complete Date</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'completedate' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='completedate' data-sort-type='asc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'completedate' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='completedate' data-sort-type='desc' onClick={(e) => SortTask(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                {!isHidden && <th className='heading-data action-heading' style={{width: "200px"}}>Actions</th>}
                            </tr>
                        </thead>
                        {
                        tasklist.length === 0 ? <p className="no-result">No results found</p> :
                            <tbody>
                                { tasklist && tasklist.length > 0 && tasklist.map((item, index) => {
                                    return (
                                        <>  
                                            <tr className='details-list-row' key={index} onClick={() => Toggle(item.idTasks)}>
                                                {!isHidden &&  
                                                <td className='details-list-data first-data' style={{minWidth: "35px"}}>
                                                    {item.status === 0 &&
                                                        <div className='checkbox-container' onClick={(e) => Check(e, item.idTasks)}>
                                                            <input id={item.idTasks} type="checkbox" name='checkbox' value={item.idTasks} className='check-box checkboxes'></input>
                                                        </div>
                                                    }
                                                </td>}
                                                <td className='details-list-data text-wrap text-break' style={{ minWidth: "170px", maxWidth: "220px", width: "220px" }}>{item.name && item.name}</td>
                                                <td className='details-list-data' style={{minWidth: "130px"}}>{item.assignedToNavigation ? ((item.assignedToNavigation['firstName'] != null) ? item.assignedToNavigation['firstName'] : '') +' '+((item.assignedToNavigation['lastName'] != null) ? item.assignedToNavigation['lastName'] : '') : 'Not Assigned'}</td>
                                                <td className='details-list-data' style={{minWidth: "120px"}}>{item.dependencyTaskNavigation && item.dependencyTaskNavigation['name'] && item.dependencyTaskNavigation['name'] ? item.dependencyTaskNavigation['name'] : '——'}</td>
                                                <td className='details-list-data' style={{minWidth: "110px"}}>{item.dueDate && convertToDateString(new Date(item.dueDate), "picker")}</td>
                                                <td className='details-list-data' style={{minWidth: "90px"}}>{item.status === 0 ? 'Incomplete' : 'Completed'}</td>
                                                <td className='details-list-data' style={{minWidth: "120px"}}>{item.priority && item.priority}</td>
                                                <td className='details-list-data' style={{minWidth: "170px"}}>{item.updatedDate && convertUTCToPST(item.updatedDate + 'Z', "updates")}</td>
                                                <td className='details-list-data' style={{minWidth: "160px"}}>{item.completeDate && item.completeDate ? convertUTCToPST(item.completeDate + 'Z', "updates") : 'N/A'}</td>
                                                {!isHidden && 
                                                <td className='details-list-data action'  style={{width: "200px"}}><img className='edit' src={edit} alt="edit" onClick={(e) => TaskEditNavigate(e, item.idTasks)}></img>
                                                <img className='trash' src={trash} alt="delete" onClick={(e) => DeleteTask(e, item.idTasks)}></img></td>}
                                            </tr>
                                            {
                                                taskid.includes(item.idTasks) &&
                                                <tr className='expanded-details-list-row'>
                                                    <td colspan="10">
                                                        <div className='role-description'>
                                                            <div className='role-content'>
                                                                <div className='role-details'>
                                                                    <div className='hide-heading'>Owner Role</div>
                                                                    <div className='hide-content'>{item.ownerRoleNavigation != null && item.ownerRoleNavigation['roleName']}</div>
                                                                </div>
                                                                <div className='role-details'>
                                                                    <div className='hide-heading'>Role Assignment</div>
                                                                    <div className='hide-content'>{item.assignedToRoleNavigation != null && item.assignedToRoleNavigation['roleName']}</div>
                                                                </div>
                                                                <div className='role-details'>
                                                                    <div className='hide-heading'>Estimate Hours</div>
                                                                    <div className='hide-content'>{item.estimatedHrs && item.estimatedHrs}</div>
                                                                </div>
                                                                <div className='role-details'>
                                                                    <div className='hide-heading'>Actual Hours</div>
                                                                    <div className='hide-content'>{item.actualHrs && item.actualHrs}</div>
                                                                </div>
                                                                <div className='role-details'>
                                                                    <div className='hide-heading'>Billable Hours</div>
                                                                    <div className='hide-content'>{item.billedHrs && item.billedHrs}</div>
                                                                </div>
                                                            </div>  
                                                            <div className='description-content'>
                                                                <div className='hide-heading'>Description</div>
                                                                <div className='hide-content description-scroll'>{item.description &&  <Descriptor defaultdescription={ item.description } setDescription={ () => {} } readOnly={true} resize={false}/>}</div>
                                                            </div>
                                                        </div>  
                                                    </td>   
                                                </tr>         
                                            }
                                        </>
                                    )
                                })}
                            </tbody>
                        }
                    </table>
                </div>
                {/* Showing delete popup */}
                <DeleteItem show={showDeleteTask} handleClose={handleCloseTaskPopup} deleteApiCall={CallDeleteTaskApi} enable={true}/>
            </div>
            <div id='files' className='files-section'>
                <div className='files-container'>
                    <div className='files-left'>
                        <div className='tasks'>Files</div>
                        {/* <div className='showing'>Showing { filelist && filelist.length } files of { allfiles && allfiles.length }</div>
                        { allfiles && allfiles.length > 5 &&
                            <div className='showall' onClick={ShowFile}>{showallfile ? "Show Less" : "Show All"}</div>
                        } */}
                    </div>
                    {!isHidden && 
                    <div className='files-right'>
                        <div className='download-button-section' onClick={() => handleDownloadImages(allfiles)}>
                            <div className='download-button'>Download All</div>
                            <div><img src={downloadBlue} alt='download'></img></div>
                        </div>
                        <div><img className='create' src={create} alt='create' onClick={handleShow}></img></div>
                        <Upload show={show} handleClose={handleClose} id={id} setUpload={setUpload} uploadstate={uploadstate} setLoadEnd={setLoadEnd} loadend={loadend} setUploaderror={setUploaderror} uploaderror={uploaderror} created={created} pageType="Projects"/>
                    </div>}
                </div>
                <div className='files-table'>
                    <table>
                        <thead>
                            <tr className='heading-row'>
                                <th className='heading-data first-data' style={{minWidth: "200px"}}>
                                    <div className='heading-arrows'>
                                        <div>Name</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'name' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='name' data-sort-type='asc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'name' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='name' data-sort-type='desc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "200px"}}>
                                    <div className='heading-arrows'>
                                        <div>Section</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'section' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='section' data-sort-type='asc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'section' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='section' data-sort-type='desc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "200px"}}>
                                    <div className='heading-arrows'>
                                        <div>Url</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'file' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='file' data-sort-type='asc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'file' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='file' data-sort-type='desc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "200px"}}>
                                    <div className='heading-arrows'>
                                        <div>Date</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'filedate' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='filedate' data-sort-type='asc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'filedate' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='filedate' data-sort-type='desc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "170px"}}>
                                    <div className='heading-arrows'>
                                        <div>Size</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'size' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='size' data-sort-type='asc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'size' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='size' data-sort-type='desc' onClick={(e) => SortFile(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                {!isHidden && <th className='heading-data action-heading' style={{width: "120px"}}>Actions</th>}
                            </tr>
                        </thead>
                        {
                        filelist.length === 0 ? <p className="no-result">No results found</p> :
                            <tbody>
                                { filelist && filelist.length > 0 && filelist.map((item, index) => {
                                    return (
                                        <tr className='details-list-row' key={index} onMouseLeave={handleMouseLeave}>  
                                            <td className='details-list-data first-data' style={{minWidth: "200px"}}>{item.fileName && item.fileName}</td>
                                            <td className='details-list-data' style={{minWidth: "200px"}}>{item.formSection && item.formSection}</td>
                                            <td className='details-list-data' style={{minWidth: "200px"}}>
                                                <div className='files-url-copy'>
                                                    <div>
                                                        <a target="_blank" href={`${BASE_URL}/${item.fileUrl && item.fileUrl.replace('\\', '/')}`}>
                                                            {item.fileUrl && item.fileUrl.replace('\\', '/')}
                                                        </a>
                                                    </div>
                                                    <CopyToClipboard
                                                        text={`${BASE_URL}/${item.fileUrl && item.fileUrl.replace('\\', '/')}`}
                                                        onCopy = {() => setTooltipMessage("Link Copied!")}>
                                                        <span>
                                                            <Tooltip title={tooltipMessage}>
                                                                <div className='icon icon-copy icon-2x'></div>
                                                            </Tooltip> 
                                                        </span>
                                                    </CopyToClipboard>                                       
                                                </div>
                                            </td>
                                            <td className='details-list-data' style={{minWidth: "170px"}}>{item.uploadedDate && convertUTCToPST(item.uploadedDate + 'Z', "updates")}</td>
                                            <td className='details-list-data' style={{minWidth: "170px"}}>{item.size && item.size}</td>
                                            {!isHidden && 
                                            <td className='details-list-data action'><a href={`${BASE_URL}/${item.fileUrl && item.fileUrl}`} download >
                                                <img className='download' src={download} alt="download"></img></a>
                                                <img className='trash' src={trash} alt="delete" onClick={(e) => DeleteFile(e, item.idFiles)}></img>
                                            </td>}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        }   
                    </table>
                </div>
                 {/* Showing delete popup */}
                 <DeleteItem show={showDeleteFile} handleClose={handleCloseFilePopup} deleteApiCall={callDeleteFileApi} enable={true}/>
            </div>       
            <div id='forms' className='forms-section'>
                <div className='forms-container'>
                    <div className='forms-left'>
                        <div className='tasks'>Forms Submission</div>
                        <div className='showing'>Showing {forms && forms.length} forms of { formsList && formsList.length }</div>
                        { formsList && formsList.length > 5 &&
                            <div className='showall'onClick={ShowForm}>{showallform ? "Show Less" : "Show All"}</div>
                        }
                    </div>
                </div>
                <div className='forms-table'>
                    <table>
                        <thead>
                            <tr className='heading-row'>
                                <th className='heading-data first-data' style={{minWidth: "200px"}}>Name</th>
                                <th className='heading-data' style={{minWidth: "200px"}}>
                                    <div className='heading-arrows'>
                                        <div>Title</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'title' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='title' data-sort-type='asc' onClick={(e) => SortForm(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'title' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='title' data-sort-type='desc' onClick={(e) => SortForm(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className='heading-data' style={{minWidth: "170px"}}>
                                    <div className='heading-arrows'>
                                        <div>Date & Time</div>
                                        <div className='sort-arrows'>
                                            {
                                                !(sort === 'formdate' && sort_order === 'asc') &&
                                                <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='formdate' data-sort-type='asc' onClick={(e) => SortForm(e.target.dataset)}></img>
                                            }
                                            {
                                                !(sort === 'formdate' && sort_order === 'desc') &&
                                                <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='formdate' data-sort-type='desc' onClick={(e) => SortForm(e.target.dataset)}></img>
                                            }
                                        </div>
                                    </div>
                                </th>
                                {!isHidden && <th className='heading-data action-heading' style={{width: "200px"}}>Actions</th>}
                            </tr>
                        </thead>
                        {
                        forms.length === 0 ? <p className="no-result">No results found</p> :
                            <tbody>
                                {forms && forms.length > 0 && forms.map((item, index) => {
                                    return (
                                        <>
                                            <tr className='details-list-row' key={index} onClick={() => handleformdata(item)}>  
                                                <td className='details-list-data first-data' style={{minWidth: "200px"}}>{`${item.contact && item.contact['firstName']}`+' '+`${(item.contact && item.contact['lastName']) ? item.contact['lastName'] : ""}`}</td>
                                                <td className='details-list-data' style={{minWidth: "200px"}}>{item.title && item.title}</td>
                                                <td className='details-list-data' style={{minWidth: "170px"}}>{item.createdDate && convertUTCToPST(item.createdDate + 'Z', "updates")}</td>
                                                {!isHidden && 
                                                <td className='details-list-data action'>
                                                    {/* {csvdata[index] && csvdata[index].length > 0 &&
                                    
                                                        <CSVLink data={csvdata[index]}
                                                        filename={item.title} 
                                                        onClick={event => {
                                                        event.stopPropagation();
                                                        }}>
                                                            <img className='download' src={download} alt="download" />
                                                        </CSVLink> 
                                                    }   */}
                                                    <img className='download' src={download} alt="download" onClick={(e) => handleFormDownload(e, item, index)}/>
                                                    <img className='trash' src={trash} alt="delete" onClick={(e) => DeleteForm(e, item.idFormSubmission && item.idFormSubmission)} />                                                
                                                </td>}
                                            </tr>
                                        </>
                                    )
                                })}
                                { formlistdata &&
                                    <FormSubmission showform={showform} handleFormHide={handleFormHide} formlistdata={formlistdata} toggle={toggle} setFormEditted={setFormEditted}/>
                                }
                            </tbody>
                        }
                    </table>
                </div>
                 {/* Showing delete popup */}
                 <DeleteItem show={showDeleteForm} handleClose={handleCloseFormPopup} deleteApiCall={CallDeleteFormApi} enable={true}/>
            </div>    
            <div className='discussion-section'>
                <h2 className='discussion-heading'>Discussions</h2>
                <div className='discussion-scroll-section'>
                    <div className='discussion-scroll-section-inner'>
                        { discussion && discussion.length > 0 && discussion.map((item, index) => {
                            return (
                                <div className={`chat-discussion ${item.author === userId ? "sender" : "other"}`} key={index}>
                                    <div className='discussion-detail'>
                                        <span className='sender-name'>{item.authorNavigation['firstName']}{' '}{item.authorNavigation['lastName']}</span><span id='date-time' className='date-time'>{ convertUTCToPST(item.createdTime + 'Z', "updates")}</span>
                                    </div>
                                    <div className='chat-details'>
                                        <div className={'chat chat-'+index}>
                                            {/* { parse((escapeHtml(item.message)).replaceAll('\n', '<br>')) } */}
                                             <DiscussionDescriptor value={item.message} setvalue={()=>{}} users={[]} post={()=> {}} readOnly={true} index={index} other={item.author !== userId}/>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                {!isHidden && 
                    <>
                        {/* <div className='d-flex align-items-center gap-4'> */}
                           
                             
                        {/* </div> */}
                        {/* <div className='discussion-error-message'>{discussinerror}</div>
                            <div className='post-container'>
                                <MentionsInput 
                                    className='custom-input'
                                    placeholder='Post'
                                    value={postdata} 
                                    allowSpaceInQuery={true}
                                    allowSuggestionsAboveCursor={true}
                                    onKeyDown={(e) => handleKey(e)}
                                    onChange={(e) => SetPostValue(e)} 
                                >
                                <Mention
                                    trigger="@"
                                    data={users}
                                    markup="<strong>@__display__</strong>"
                                    appendSpaceOnAdd='true'
                                />
                            </MentionsInput>
                            
                            <div>
                                <img src={post} onClick={Post}></img>
                            </div>
                        </div> */}
                    </>
                }
            </div> 
            {!isHidden && 
            <div className='ms-5'>
                <DiscussionDescriptor value={postdata} setvalue={SetPost} users={users} post={sendDiscussion}/>
            </div> }
            <Snackbars error={taskerror} open={open} setOpen={setOpen}/>
        </div>
    );
}

export default ProjectInfo;